import * as analytics from 'analytics/Analytics';
import BenchlingConfig from 'BenchlingConfig';
import {COLLABORATION_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import TemplateActions from 'notebook/entry-templates/TemplateActions';
import TemplateStore from 'notebook/entry-templates/TemplateStore';
import {RealtimeMessageType} from 'realtime/Constants';
import {getCollaborationAnalyticsMetadata} from 'realtime/util/analytics/CollaborationAnalyticsMetadata';
import {isCurrentClient} from 'realtime/util/RealtimeUtil';
import APIUtil from 'util/APIUtil';

import type {DocumentUpdateMessageHandler} from './DocumentUpdateMessageHandlerConstants';

function isRealtimeTemplate(fileId: string): boolean {
  return APIUtil.isEntryTemplate(fileId) && BenchlingConfig.ELN_REALTIME_TEMPLATE_UPDATES;
}

export const publishingUpdateMessageHandler: DocumentUpdateMessageHandler<
  typeof RealtimeMessageType.PUBLISHING_UPDATE
> = {
  active: (fileId, {clientId}) => {
    if (!isRealtimeTemplate(fileId) || !clientId || isCurrentClient(clientId)) {
      return;
    }

    TemplateActions.refreshPublishingState(fileId);
    analytics.trackEvent(
      COLLABORATION_ANALYTICS_ACTIONS.RECEIVED_REALTIME_UPDATE,
      getCollaborationAnalyticsMetadata(fileId)
    );

    if (TemplateStore.inStore(fileId)) {
      const editorState = TemplateStore.getEditorState(fileId);
      // Don't update the item if the client is viewing an old version, but refresh the history so it
      // lists the new version
      if (editorState.openVersionId !== editorState.metadata?.latestVersionId) {
        TemplateActions.fetchVersions(fileId);
        return;
      }
      // Don't update the item if the current user has started editing
      if (TemplateStore.hasUnsavedChanges(fileId)) {
        return;
      }
    }
    TemplateActions.open(fileId, {});
  },
  inactive: (fileId, {clientId}) => {
    if (!isRealtimeTemplate(fileId) || !clientId || isCurrentClient(clientId)) {
      return;
    }

    TemplateActions.refreshPublishingState(fileId);
    if (TemplateStore.inStore(fileId)) {
      TemplateActions.postServerUpdate(fileId, {isStale: true});
    }
  },
};
